module.exports = __webpack_public_path__ + "static/media/am115_battleship.a11939e7.png";